module.exports = __webpack_public_path__ + "static/media/Schnyder L Demi.2a43e48d.otf";